import React, {useState} from 'react';
import {Text, TouchableOpacity} from 'react-native';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import {styles} from './styles';

interface ICheckBoxVessel {
  returnCheck: (check: boolean) => void;
}
const ChecBoxVessel = ({returnCheck}: ICheckBoxVessel) => {
  const [check, setCheck] = useState<boolean>(false);

  return (
    <TouchableOpacity
      onPress={() => {
        returnCheck(!check);
        setCheck(!check);
      }}
      style={styles.touchableOpacity}>
      {check ? (
        <MaterialCommunityIcons
          name="checkbox-marked"
          size={20}
          style={styles.icon}
        />
      ) : (
        <MaterialCommunityIcons
          name="checkbox-blank-outline"
          size={20}
          style={styles.icon}
        />
      )}
      <Text style={styles.text}>Confirmar posse dos vasilhames</Text>
    </TouchableOpacity>
  );
};

export default ChecBoxVessel;
